
import Vue from 'vue';
import { SupportChatBot } from '../helpers/supportChatBot';

export default Vue.extend({
  props: {},
  data() {
    return {
      isChatLoaded: false,
      isChatLoading: false,
    };
  },
  computed: {
    showButton(): boolean {
      return !this.isChatLoaded && !this.isChatLoading;
    },
  },
  methods: {
    loadChatBot() {
      SupportChatBot.loadChatBot();

      this.isChatLoading = true;
      setTimeout(() => {
        this.isChatLoading = false;
        this.isChatLoaded = true;
      }, 2500);
    },
  },
});
